<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t('keywords.register')}}</v-toolbar-title>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.key.identifier)"
                  name="sequence.key.identifier"
                  :label="$t('sequence.name')"
                  v-model="objEditar.key.identifier"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :rules="requiredRules(objEditar.value)"
                  :label="$t('sequence.value')"
                  v-model="objEditar.value"
                  type="number"
                  min="0"
                  step="1"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <br />
    <v-col cols="12" class="text-right">
      <v-btn color="success" class="mr-1" @click="saveItem">{{$t('button.save')}}</v-btn>
      <v-btn color="blue darken-1" text @click="close">{{$t('button.cancel')}}</v-btn>
    </v-col>
  </v-container>
</template>

<script>
import Servico from '@/services/SequenceService'
import LocalStorageService from '@/services/LocalStorageService'
import { alphaNumericRules, requiredRules } from '../../utils/rules'

export default {
  name: 'SequenceForm',

  props: {
    identifier: String
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    objEditar: {
      key: {
        identifier: '',
        clientPrefix: LocalStorageService.getClientPrefix()
      },
      value: 0
    },
    isUpdating: false
  }),

  mounted () {
    this.loadData()
  },

  methods: {
    loadData () {
      if (this.identifier) {
        Servico.findById(this.identifier)
          .then(({ data }) => {
            this.isUpdating = true
            this.objEditar = data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()
      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }
}
</script>
